import { useNuxtApp } from '#app'

export const formsRepository = () => {
  const { $api } = useNuxtApp()

  return {
    async contacts(formData: FormData): Promise<{ response: { status: boolean; message: string } }> {
      const response = await $api<{ status: boolean; message: string }>(`contacts`, {
        method: 'POST',
        body: formData,
      })

      return {
        response,
      }
    },
    async suggestPlace(formData: FormData): Promise<{ response: { status: boolean; message: string } }> {
      const response = await $api<{ status: boolean; message: string }>(`place-suggestion`, {
        method: 'POST',
        body: formData,
      })

      return {
        response,
      }
    },
    async joinExpert(formData: FormData): Promise<{ response: { status: boolean; message: string } }> {
      const response = await $api<{ status: boolean; message: string }>(`expert`, {
        method: 'POST',
        body: formData,
      })

      return {
        response,
      }
    },
    async clicks(placeId: string): Promise<{ response: { status: boolean; message: string } }> {
      const response = await $api<{ status: boolean; message: string }>(`places/${placeId}/clicks`, {
        method: 'POST',
      })
      return {
        response,
      }
    },
  }
}
